import { defineComponent as _defineComponent } from 'vue'
import { useThemeModel } from '@entities/theme'


export default /*#__PURE__*/_defineComponent({
  __name: 'PaymentAllBanksButton',
  setup(__props) {


const themeModel = useThemeModel()

return { __sfc: true,themeModel }
}

})